export const mufStarterKitFeatureKey = 'mufStarterKit';
